import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import FeedbackPopup from '../Common/FeedbackPopup';
import FooterComponent from '../Common/FooterComponent';
import ExtensionNavbar from './ExtensionNavbar';
/* global gtag */

const affiliateSignupUrl = "https://easyimagetotext.lemonsqueezy.com/affiliates";

function SheetsExtensionAffiliate(){

    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const navigate = useNavigate();
    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 

    useEffect(() => {
        document.title = "Convert PDF to Google Sheets in 1 click | Convert PDF Bank Statement to CSV | 1-click PDF to Google Sheets Converter, PDF to CSV converter";
    }, []);
    
    const initiateAffiliateOnboarding = e => {
        //event tracker
            gtag('event', 'affiliate_clicked', {
                event_category: 'Button',
                event_label: 'Affiliate'
            });
        //
        try{
           navigate(`/sheets-extension-affiliate-onboarding`);
        }catch(err){
            console.log('error in initiateAffiliateOnboarding method: ', err);
            
        }
    }

    const openAffiliateKit = e => {
        try{
            navigate(`/sheets-extension-affiliate-kit`);
        }catch(err){
            console.log('error in openAffiliateKit method: ', err);
            
        }
    }

    const openPricingPage = e => {
        try{
            window.open(
                'https://www.easyimagetotext.com/sheets-extension-pricing',
                "_blank"
            );
        }catch(err){
            console.log('error in openPricingPage method: ', err);
            
        }
    }

    return(
        <div className='parentDiv'>
            <div className='mainDiv privacyPolicy'>
                <div className='header'>
                    <ExtensionNavbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv' style={{width: '80%'}}>
                        <div className='title'>Become an Affiliate</div>
                        <div className='contentBox' style={{alignItems: 'normal'}}>
                            <div className='content' style={{width: '90%', height: 'auto'}}>
                                <div style={{fontSize: '18px'}}>
                                    <pre style={{fontFamily: 'sans-serif', textWrap: 'auto'}}>
                                        💰 Earn 30% commission per sale – with unlimited recurring payouts (<span style={{color: 'forestgreen', textDecoration: 'underline', fontStyle: 'italic', cursor: 'pointer'}} onClick={openPricingPage}>See our plans</span>)<br/><br/>
                                        🔁 Every renewal, you keep earning <br/><br/>
                                        🍪 Cookie duration: 90 days <br/><br/>
                                        💵 Minimum payout: $10 <br/><br/>
                                        💳 Payout done on NET30 terms (<span style={{display: 'inline-block', fontSize: '16px'}}>to account for refunds and chargebacks</span>) <br/><span style={{display: 'inline-block', marginTop: '5px', marginLeft: '30px', fontSize: '13px'}}>(For example, commissions generated in January would be paid out on March 15th (NET30))</span> <br/><br/>
                                        💯 Powered by Lemon Squeezy (✅ Transparent Tracking   ✅ Automated Commission Processing)<br/><br/><br/>
                                        <div className='linkWrapper'>
                                            <div><span className='affiliateLearnMoreLink' onClick={initiateAffiliateOnboarding}>Join the Affiliate Program</span></div>
                                            {/* <div><span className='affiliateKitLink' onClick={openAffiliateKit}>Get the Affiliate Kit</span></div> */}
                                        </div>
                                    </pre>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>            
            <FooterComponent forSheetsExtension={true} setShowFeedbackPopup={setShowFeedbackPopup}/>
            {/* <div style={{position: 'sticky', bottom: '10px'}}>
                <a href={"https://affiliate.watch/affiliate/easy-image-to-text"} target="_blank" style={{display: 'inline-block', lineHeight: 0}}>
                    <img src={"https://affiliate.watch/api/affiliate-badge/2619/featured-purple-bg-white-text"} alt="Featured as a Top Affiliate Program on Affiliate.Watch" style={{height: '80px'}}/>
                </a>
            </div> */}
        </div>
    )
}

export default SheetsExtensionAffiliate;